import React from "react";
import "./CustomDevelopmentHero.css";

import customDevelopmentHeroLuminousSystemBackground from "../../images/custom-development-hero-luminous-system-background.svg";
import customDevelopmentHeroOperatingSystemMapDesktop from "../../images/custom-development-hero-operating-system-map-desktop.svg";
import customDevelopmentHeroOperatingSystemMapMobile from "../../images/custom-development-hero-operating-system-map-mobile.svg";

export default function CustomDevelopmentHero({
  scopeHref = "#custom-development-scope",
  consultingHref = "#custom-development-consulting",
}) {
  return (
    <section
      className="custom-development-hero"
      id="custom-development-top"
      aria-labelledby="custom-development-hero-title"
    >
      <img
        className="custom-development-hero__background"
        src={customDevelopmentHeroLuminousSystemBackground}
        alt=""
        aria-hidden="true"
      />

      <div className="custom-development-hero__inner">
        <div className="custom-development-hero__copy">
          <p className="custom-development-hero__eyebrow">Custom Intelligent Systems</p>
          <h1 id="custom-development-hero-title">
            Your business does not need more software. It needs a system that fits the work.
          </h1>
          <p className="custom-development-hero__body">
            We design and build AI-enabled platforms, CRMs and operational workflows
            around your processes, people and performance goals.
          </p>

          <div className="custom-development-hero__actions">
            <a className="custom-development-hero__action custom-development-hero__action--primary" href={scopeHref}>
              <span>Scope your system</span><span aria-hidden="true">→</span>
            </a>
            <a className="custom-development-hero__action custom-development-hero__action--secondary" href={consultingHref}>
              <span>Book AI consulting</span><span aria-hidden="true">→</span>
            </a>
          </div>

          <p className="custom-development-hero__capability">
            <span aria-hidden="true" /> Platforms · CRMs · Intelligent workflows
          </p>
        </div>

        <picture className="custom-development-hero__visual">
          <source media="(max-width: 699px)" srcSet={customDevelopmentHeroOperatingSystemMapMobile} />
          <img src={customDevelopmentHeroOperatingSystemMapDesktop} alt="People, process, data and decisions connected around one business operation." />
        </picture>
      </div>
    </section>
  );
}
